<div class="c-modal c-modal--md" id="modal-{{vm.uid}}">
    <div mat-dialog-content class="c-modal__dialog">
        <div class="c-modal__header">
            <div class="o-grid">
                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
                    <button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
                        <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-modal__content u-no-pt">
            <div class="c-card c-card--height-fit" style="box-shadow:none;">
                <p class="c-text c-text--center">{{ 'Training.Create.Success_Message' | translate }}</p>
                <div class="o-grid__cell o-grid__cell--center-h" style="margin-top: 15px;">
                    <button
                            type="button"
                            id="closeButton"
                            (click)="vm.close()"
                            [routerLink]="['/training-programs']"
                            class="c-button c-button--s1 u-no-wrap">
                        {{ 'Training.Create.Back_To_Programs' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
